import React from 'react';
import ViewSmall from '../../../../../../ui_components/MediaView/ViewSmall';
import ViewMedium from '../../../../../../ui_components/MediaView/ViewMedium';
import ViewLarge from '../../../../../../ui_components/MediaView/ViewLarge';
import ReferenceItemSalePriceRowMedium from './ReferenceItemSalePriceRowMedium';
import ReferenceItemSalePriceRowProperties from './ReferenceItemSalePriceRowProperties';


const ReferenceItemSalePriceRow: React.FC<ReferenceItemSalePriceRowProperties> = ({
                                                    referenceItem,
                                                    salePrice,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <ReferenceItemSalePriceRowMedium onUpdate={onUpdate} referenceItem={referenceItem} salePrice={salePrice}/>
            </ViewSmall>
            <ViewMedium>
                <ReferenceItemSalePriceRowMedium onUpdate={onUpdate} referenceItem={referenceItem} salePrice={salePrice}/>
            </ViewMedium>
            <ViewLarge>
                <ReferenceItemSalePriceRowMedium onUpdate={onUpdate} referenceItem={referenceItem} salePrice={salePrice}/>
            </ViewLarge>
        </>
    )
}

export default ReferenceItemSalePriceRow;
